import RedirectorResource from "./redirector.resource";

const redirectorModule = angular
  .module("app.resources.redirector", [])
  .service("Redirector", RedirectorResource);

export default redirectorModule;



// WEBPACK FOOTER //
// ./src/resources/redirector/redirector.module.js